import React, { useState } from 'react'
import IconBox from '../shared/IconBox'
import mines from "../../assets/img/icons/Vector.svg"
import add from "../../assets/img/icons/add.svg"
const CountBox = ({className,abs,count,setCount}) => {
    
    const increase = ()=>{
        setCount(prev=>prev+=1)
    }
    const decrease = ()=>{
        if(count > 0){
            setCount(prev=>prev-=1)

        }
    }
  return (
    <div className={`CountBox ${ abs?"": "dropbox-absolute "} ${className}`} onClick={e=>e.stopPropagation()}>
        <div className='CountBox__header center'>
        تعداد نفرات
        </div>
        <div className='CountBox__container flex justify-between items-center'>
            <IconBox onClick={increase} white className="CountBox__iconbox"><img width={24} src={add} /></IconBox>
            <p>{count} نفر</p>
            <IconBox onClick={decrease}  white className="CountBox__iconbox"><img width={12} src={mines} /></IconBox>


        </div>
    </div>
  )
}

export default CountBox